import { render, staticRenderFns } from "./SidebarMergeService.vue?vue&type=template&id=15c16d78"
import script from "./SidebarMergeService.js?vue&type=script&lang=js&external"
export * from "./SidebarMergeService.js?vue&type=script&lang=js&external"
import style0 from "./SidebarMergeService.vue?vue&type=style&index=0&id=15c16d78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports